module.exports = __webpack_public_path__ + "img/turkish_delight.22a2c40c.gif";